import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { PaystackButton } from "react-paystack";
import { API_URL } from "../config";
// import { updateStudentCoins } from "../utils/coin";
import { CircularProgress } from "@mui/material";
import { updateStudentCoins } from "../utils/coin";
import { PaystackButton } from "react-paystack";
import { toast } from "react-toastify";

const PaystackStudentsPaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    studentDetails = [],
    amount,
    email,
    publickey,
    totalStudents,
    coins,
  } = location.state || {};

  const [authToken, setAuthToken] = useState(null);
  const [currency, setCurrency] = useState("USD");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paymentReference, setPaymentReference] = useState(null);
  const [backendCurrency, setBackendCurrency] = useState(null);

  useEffect(() => {
    const refreshCoins = async () => {
      try {
        await updateStudentCoins();
      } catch (err) {
        console.error("Failed to update coins");
      }
    };
    refreshCoins();
  }, []);
  // Fetch auth token and user currency
  useEffect(() => {
    const init = async () => {
      try {
        const tokenString = localStorage.getItem("authToken");
        if (!tokenString) throw new Error("No auth token found");

        const token = JSON.parse(tokenString);
        setAuthToken(token);

        const response = await fetch(`${API_URL}/user/country/`, {
          headers: { Authorization: `Bearer ${token.access}` },
        });

        if (!response.ok) throw new Error("Failed to fetch user profile");

        const data = await response.json();
        setCurrency(data.country.currency);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);
  const numericAmount = parseFloat(amount);
  // Generate payment reference before Paystack
  const generatePaymentReference = async () => {
    if (!authToken) throw new Error("No auth token found");

    const response = await fetch(`${API_URL}/generate-payment-reference/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken.access}`,
      },
      body: JSON.stringify({
        amount: numericAmount, // required
        studentDetails, // required
      }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      console.error("Failed to generate payment reference:", errData);
      throw new Error(
        errData.message || "Failed to generate payment reference"
      );
    }

    return response.json(); // contains { reference, currency, message }
  };

  useEffect(() => {
    const preparePayment = async () => {
      try {
        const data = await generatePaymentReference();
        setPaymentReference(data.reference);
        setBackendCurrency(data.currency);
      } catch (err) {
        console.error(err);
        setError(err.message);
      }
    };

    if (authToken && numericAmount) {
      preparePayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, numericAmount]);

  const componentProps = {
    email,
    amount: numericAmount * 100, // convert to kobo
    currency: backendCurrency || currency,
    publicKey: publickey.trim(),
    reference: paymentReference,
    text: "Make Payment",
    onSuccess: async (response) => {
      console.log("Payment successful:", response);

      await updateStudentCoins();
      toast.success(`Payment Successful! You have received ${coins} Golds`);
      navigate("/golds");
    },
    onClose: () => {
      toast.error("Payment Cancelled");
      navigate("/golds");
    },
    className: "custom-paystack-button",
  };

  // const handlePayment = async () => {
  //   try {
  //     setLoading(true);

  //     // Step 1: Generate payment reference
  //     const data = await generatePaymentReference();
  //     const { reference, currency: backendCurrency } = data;
  //     setPaymentReference(reference);
  //     setCurrency(backendCurrency || currency);

  //     // Step 2: Setup Paystack
  //     const handler = window.PaystackPop.setup({
  //       key: publickey,
  //       email,
  //       amount: amount * 100, // convert to kobo
  //       currency: backendCurrency || currency,
  //       ref: reference,
  //       callback: async () => {
  //         // Step 3: Update coins after successful payment
  //         await updateStudentCoins();
  //         alert("Payment successful! Coins updated.");
  //         navigate("/students");
  //       },
  //       onClose: () => {
  //         alert("Payment cancelled");
  //         navigate("/students");
  //       },
  //     });

  //     handler.openIframe();
  //   } catch (err) {
  //     console.error(err);
  //     setError(err.message);
  //     setLoading(false);
  //   }
  // };
  // console.log(paymentReference);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div style={{ minHeight: "600px" }}>
      <div className="payment-summary-card">
        <h2>Payment Summary</h2>
        <p>
          <strong>Total Amount: </strong>
          {amount} {currency}
        </p>
        <p>
          <strong>Total Students:</strong> {totalStudents}
        </p>
        <div>
          <strong>Payment Details:</strong>
          <ul>
            {studentDetails.map((detail, idx) => (
              <li key={idx}>
                {detail.email}: {detail.amount}
              </li>
            ))}
          </ul>
        </div>
        <div className="modal-actions">
          <button onClick={() => navigate(-1)} className="cancel-button">
            Close
          </button>{" "}
          {paymentReference ? (
            <PaystackButton {...componentProps} />
          ) : (
            <CircularProgress />
          )}
        </div>
      </div>
    </div>
  );
};

export default PaystackStudentsPaymentPage;
